import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../redux/hooks';
import { resetIncident } from '../redux/store';
import { photoStorage } from '../services/photoStorage';
import Insights from '../services/insightsService';

export default function useAbandonIncident(): { onAbandonPress: () => void } {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onAbandonPress = () => {
    Modal.confirm({
      title: 'Abandon Incident?',
      content: 'Are you sure you want to abandon this incident? All progress will be lost.',
      okText: 'Yes, Abandon',
      cancelText: 'Cancel',
      okButtonProps: { danger: true },
      onOk: async () => {
        Insights.trackEvent('abandon-incident');
        dispatch(resetIncident());
        await photoStorage.clearAll();
        navigate('/home');
      },
    });
  };

  return { onAbandonPress };
}
